module.exports = "/_next/static/images/d2a1cbe01f54c5817b55a963d28e1f39-hot-sale-hero-mobile.jpg.webp";